import { ApiOrderFilter, OrdersFilter } from "../../models/Filter";
import { OrderState } from "../../utils/constants";

export const numberOrNull = (value: string | number) => {
  if (typeof value === "string") {
    return value ? Number(value) : null;
  }

  return value;
};

export const nonEmptyStringOrNull = (value: string) => {
  return value || null;
};

export const nonEmptyArrayOrNull = (value: any) => {
  return Array.isArray(value) && value.length ? value : null;
};

const states: Record<string, number[]> = {
  active: [OrderState.Pending, OrderState.Pause],
  inactive: [OrderState.Invisible],
};

interface MapFilterObject extends Omit<OrdersFilter, "pageSize" | "page"> {
  pageSize: number | null;
  page: number | null;
}

export const mapFilterObject = ({
  deliveryDate,
  destinationCity,
  destinationState,
  originCity,
  originState,
  pickupDate,
  search,
  page,
  pageSize,
  customerId,
  itemStates,
  vinAge,
  vinPriority,
  vinEquality,
  vehicleModel,
}: MapFilterObject): ApiOrderFilter => {
  return {
    customer: {
      id: numberOrNull(customerId),
    },
    pickup: {
      citySearch: nonEmptyStringOrNull(originCity.trim()),
      stateSearch: nonEmptyStringOrNull(originState),
      appointment: {
        from: nonEmptyStringOrNull(pickupDate),
        to: null,
      },
    },
    delivery: {
      citySearch: nonEmptyStringOrNull(destinationCity.trim()),
      stateSearch: nonEmptyStringOrNull(destinationState),
      appointment: {
        from: nonEmptyStringOrNull(deliveryDate),
        to: null,
      },
    },
    search,
    pageSize,
    page,
    states: states[itemStates],
    orderVinAging: {
      age: numberOrNull(vinAge),
      condition: nonEmptyStringOrNull(vinEquality),
      priority: nonEmptyArrayOrNull(vinPriority),
    },
    attachedToShipment: false,
    vehicleModel: nonEmptyStringOrNull(vehicleModel),
  };
};
